import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
export default {
  name: 'goods_drawer_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      rules: {
        type: [{
          required: true,
          message: '请选择抽屉头部配置方式',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '名称不可为空',
          trigger: 'change'
        }, {
          min: 1,
          max: 10,
          message: '字数应大于等于1个字符小于10个字符!',
          trigger: 'change'
        }],
        more_name: [{
          required: true,
          message: '查看更多文案不可为空',
          trigger: 'change'
        }],
        header_image: [{
          required: true,
          message: '抽屉头部图片不可为空',
          trigger: 'change'
        }],
        category_id: [{
          required: true,
          message: '菜单不可为空',
          trigger: 'change'
        }],
        number: [{
          required: true,
          pattern: /^(?:[5-9]|1[0-9]|20)$/,
          message: '商品数量需在5-20之间',
          trigger: 'change'
        }],
        bg_color: [{
          required: true,
          message: '背景色不可为空',
          trigger: 'change'
        }]
        // sort: [
        // 	{ required: true, message: '展示逻辑不可为空', trigger: 'change' }
        // ]
      },
      showPictureLibrary: false,
      pictureList: [],
      depot: {}
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.$set(this.value.config, 'header_image', path);
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture() {
      // pictureList: 图库中图片列表
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload() {
      this.$refs.uploadBanner.uploadBanner();
    },
    emitUploadFile: function emitUploadFile(url) {
      this.$set(this.value.config, 'header_image', "".concat(this.$ossurl).concat(url));
    },
    onDelete: function onDelete() {
      var _this2 = this;
      if (!this.value.config.header_image) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.$set(_this2.value.config, 'header_image', '');
      });
    }
  },
  created: function created() {
    this.getPicture();
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$nu = _this$value$config.number,
      number = _this$value$config$nu === void 0 ? 5 : _this$value$config$nu;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({
      type: '1',
      name: '正在热映',
      more_name: '查看更多',
      header_image: 'https://res.youlianfuwu.com/mini_program/shop/film_preset.png',
      bg_color: '#ffffff',
      category_id: ''
    }, this.value.config), {}, {
      number: number,
      //默认展示5个商品
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index //兼容新老组件 默认预置2
    }));
  },
  computed: {
    menuListFilter: function menuListFilter() {
      return this.menuList.filter(function (i) {
        return i.type === 'movie';
      });
    }
  }
};